import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accessibilite',
  templateUrl: './accessibilite.component.html',
  styleUrls: ['./accessibilite.component.css']
})
export class AccessibiliteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
